import React from "react";
import {
  FaShoppingCart,
  FaChevronRight,
  FaChevronLeft,
} from "react-icons/fa";
import ButtonUI from "./Button";
import SellBanner from "./SellBanner";

const HeaderUI = ({
  brand,
  isLoggedIn,
  cartCount,
  onNavigateHome,
  onNavigate,
  onOpenCart,
  onLogin,
  onLogout,
}) => {
  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-white">

      {/* Sell Banner */}
      {<SellBanner />}

      {/* Top bar */}
      <div className="flex flex-col items-center justify-center px-6 py-5">

        {/* Brand */}
        <div
          onClick={onNavigateHome}
          className="text-2xl sm:text-3xl font-bold text-green-900 cursor-pointer tracking-tight"
        >
          {brand}
        </div>

        {/* Slogan */}
        <p className="mt-1 text-sm sm:text-base text-gray-600 text-center">
          Buy and Sell Second Hand Items in Swellendam and Nearby Areas
        </p>

        {/* Right side */}
        <div className="flex items-center gap-3">

          {/* Cart - kept for later, currently hidden */}
          {!isLoggedIn && (
            <div className="hidden relative">
              <ButtonUI variant="outline" onClick={onOpenCart}>
                <FaShoppingCart />
                <span className="hidden sm:inline">Order</span>
              </ButtonUI>

              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-green-900 text-white text-[10px] px-2 py-[2px] rounded-full">
                  {cartCount}
                </span>
              )}
            </div>
          )}

          {/* Auth - sign in hidden for now */}
          {!isLoggedIn ? (
            <div className="hidden">
              <ButtonUI onClick={onLogin}>
                Sign in
              </ButtonUI>
            </div>
          ) : (
            <ButtonUI variant="outline" onClick={onLogout}>
              Logout
            </ButtonUI>
          )}

        </div>
      </div>

      {/* PUBLIC MARKETPLACE NAVIGATION */}
      {!isLoggedIn && (
        <nav className="border-t border-gray-100 bg-white">

          <div className="flex justify-center px-4 py-4">

            {/* ATTENTION CTA */}
            <div className="relative flex items-center">

              {/* OUTER PULSE */}
              <div className="absolute inset-0 rounded-xl border-2 border-green-400 animate-ping opacity-20 pointer-events-none" />

              {/* LEFT ARROWS */}
              <div className="flex items-center mr-2 sm:mr-4 text-green-700">

                <FaChevronRight
                  className="text-sm sm:text-base animate-[attentionArrow_1s_ease-in-out_infinite]"
                />

                <FaChevronRight
                  className="text-lg sm:text-xl animate-[attentionArrow_1s_ease-in-out_0.25s_infinite]"
                />

              </div>

              {/* BUTTONS */}
              <div className="flex items-center gap-2 sm:gap-3">

                {/* FOR SALE */}
                <button
                  onClick={() => onNavigate("/menu")}
                  className="
                    relative
                    px-5 py-2.5
                    sm:px-7 sm:py-3
                    rounded-xl
                    bg-green-800
                    text-white
                    text-sm sm:text-base
                    font-extrabold
                    tracking-wide
                    shadow-lg
                    border-2 border-green-600
                    animate-[attentionButton_2s_ease-in-out_infinite]
                    hover:bg-green-900
                    hover:scale-105
                    transition
                  "
                >
                  <span className="relative z-10">
                    FOR SALE
                  </span>

                  <span className="absolute inset-0 rounded-xl border-2 border-green-300 animate-pulse pointer-events-none" />
                </button>

                {/* WANTED */}
                <button
                  onClick={() => onNavigate("/want-menu")}
                  className="
                    relative
                    px-5 py-2.5
                    sm:px-7 sm:py-3
                    rounded-xl
                    bg-blue-700
                    text-white
                    text-sm sm:text-base
                    font-extrabold
                    tracking-wide
                    shadow-lg
                    border-2 border-blue-500
                    animate-[attentionButton_2s_ease-in-out_0.4s_infinite]
                    hover:bg-blue-800
                    hover:scale-105
                    transition
                  "
                >
                  <span className="relative z-10">
                    WANTED
                  </span>

                  <span className="absolute inset-0 rounded-xl border-2 border-blue-300 animate-pulse pointer-events-none" />
                </button>

              </div>

              {/* RIGHT ARROWS */}
              <div className="flex items-center ml-2 sm:ml-4 text-green-700">

                <FaChevronLeft
                  className="text-lg sm:text-xl animate-[attentionArrow_1s_ease-in-out_0.25s_infinite]"
                />

                <FaChevronLeft
                  className="text-sm sm:text-base animate-[attentionArrow_1s_ease-in-out_infinite]"
                />

              </div>

            </div>

          </div>

        </nav>
      )}

      {/* LOGGED IN NAVIGATION */}
      {isLoggedIn && (
        <nav className="border-t border-gray-100 bg-white">

          <div className="flex items-center justify-center gap-8 px-6 py-3 text-sm">

            <button
              onClick={() => onNavigate("/dashboard")}
              className="text-gray-600 hover:text-green-800 transition font-medium"
            >
              Dashboard
            </button>

            <button
              onClick={() => onNavigate("/manage-menu")}
              className="text-gray-600 hover:text-green-800 transition font-medium"
            >
              Manage Listings
            </button>

          </div>

        </nav>
      )}

    </header>
  );
};

export default HeaderUI;